import { render, staticRenderFns } from "./BowLocomotiveScrollCols.vue?vue&type=template&id=a48ce338&"
import script from "./BowLocomotiveScrollCols.vue?vue&type=script&lang=js&"
export * from "./BowLocomotiveScrollCols.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports